import React from 'react';
import { IconProps } from './IconProps';

const AdjustmentsHorizontalIcon: React.FC<IconProps> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}>
    <path d="M21 12h-8" />
    <path d="M11 12H3" />
    <path d="M12 21v-8" />
    <path d="M12 11V3" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

export default AdjustmentsHorizontalIcon;
